import PropTypes from 'prop-types';
import React from 'react';
import CSSModules from 'react-css-modules';
import { FormattedMessage } from 'react-intl';
import styles from './debitCardForm.scss';

const CVV_LENGTH = 3;
const cvvValidateRegex = new RegExp('^\\d{0,' + CVV_LENGTH + '}$');

class CvvInput extends React.Component {

  static propTypes = {
    name: PropTypes.string,
    onChange: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }

  handleOnChange = (e) => {
    const {target: elem} = e;
    const {value} = elem;


    if (!cvvValidateRegex.test(value)) {
      return;
    }

    this.setState(() => ({value}), () => {
      if (this.props.onChange) {
        this.props.onChange(this.state.value.length === CVV_LENGTH ? this.state.value : '', this.props.name);
      }
    });
  }

  render() {
    return (
      <div styleName="inputGroupColumn">
        <label><FormattedMessage id="updateDebitCard.form.cvv"/></label>
        <div data-at="cvvInput" styleName="cvvInput">
          <input name="cvv" value={this.state.value} type="text" pattern="[0-9]*" placeholder="cvv" onChange={this.handleOnChange} />
        </div>
      </div>
    );
  }
}

export default CSSModules(styles, {allowMultiple: true})(CvvInput);



// WEBPACK FOOTER //
// ./src/components/common/debitCardForm/CvvInput.js